module.exports = __webpack_public_path__ + "static/media/Sukra.0fdf0ff4.png";